const CROSS_ORIGIN_ISOLATED_ROUTE_PATTERNS = [
  /^\/[a-z]{2}\/dict(?:\/|$)/,
  /^\/[a-z]{2}\/home$/,
  /^\/[a-z]{2}\/collections$/,
  /^\/[a-z]{2}\/settings$/,
  /^\/[a-z]{2}\/onboarding$/,
  /^\/[a-z]{2}\/read$/,
  /^\/[a-z]{2}\/read\/import$/,
  /^\/[a-z]{2}\/read\/document(?:\/|$)/
] as const

export function normalizePathname(pathname: string) {
  return pathname.replace(/\/+$/, '') || '/'
}

export function isCrossOriginIsolatedPathname(pathname: string) {
  const normalizedPathname = normalizePathname(pathname)
  return CROSS_ORIGIN_ISOLATED_ROUTE_PATTERNS.some((pattern) =>
    pattern.test(normalizedPathname)
  )
}
